export default __webpack_public_path__ + "static/media/advantageTitleBg.9e57eeb3.png";